export default __webpack_public_path__ + "static/media/linkedin.9a77fd8e.svg";